import React from 'react'
import Header from "../header/header";
import Menu from "../menu/menu";
import Cards from "../cards/cards";
import Welcome from "../welcome/welcome";
import { useFindMenuId } from "../menu/utils";

const Home = () => {
    return <div>
        <Header />
        <Menu />
        <Welcome />
        <Cards item_id={useFindMenuId()} />
    </div>
}

export default Home